import firebase from './Firebase';

let domain = window.location.href.replace(/^(http?s:\/\/[^/]+).*$/, '$1');
let api_url = process.env.REACT_APP_API_ENDPOINT.startsWith(domain) ? process.env.REACT_APP_API_ENDPOINT : process.env.REACT_APP_API_ENDPOINT_2;
let API_CACHE = {};

export default class API {
  static post = async(formdata, type) => {
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType = type;
      //xhr.withCredentials = true;
      xhr.onload = function() {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }
  static get = async(formdata, type) => {
    return new Promise((resolve, reject)=>{
      let search = Object.keys(formdata).map(key=>{
        return key + '=' + encodeURIComponent(formdata[key]);
      }).join('&');
      let xhr = new XMLHttpRequest();
      xhr.open('get', api_url+'?'+search, true);
      xhr.responseType = type;
      //xhr.withCredentials = true;
      xhr.onload = function() {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(xhr.statusText);
      }
      xhr.send();
    });
  }

  static getStaticFile = async (file) => {
    let formdata = new FormData();
    formdata.append('method', 'getStaticFile');
    formdata.append('file', file);
    return API.post(formdata, 'blob');
  }

  static getUserAttributes = async () => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getUserAttributes');
    formdata.append('idToken', idToken);
    return API.post(formdata, 'json');
  }

  static getCustomers = async () => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getCustomers');
    formdata.append('idToken', idToken);
    return API.post(formdata, 'json');
  }

  static getCustomerInfo = async (customerCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getCustomerInfo');
    formdata.append('customerCode', customerCode);
    formdata.append('idToken', idToken);
    return API.post(formdata, 'json');
  }

  // 進捗状況 アルバム一覧
  static listAlbums = async (customerCode, edaban, bunrui) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listAlbums');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      customerCode: customerCode,
      edaban: edaban,
      bunrui: bunrui
    }));
    return API.post(formdata, 'json');
  }

  // 進捗状況 アルバム情報
  static getAlbum = async (albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getAlbum');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      albumCode: albumCode
    }));
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType ='json';
      xhr.onload = function() {
        if (xhr.status === 200) {
          // chromeではresponseのデータを変更できない
          let data = JSON.parse(JSON.stringify(xhr.response));
          data.code = albumCode;
          resolve(data);
        }
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }

  static getSearchPropsFromCode = async (albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getSearchPropsFromCode');
    formdata.append('idToken', idToken);
    formdata.append('code', albumCode);
    return API.post(formdata, 'json');
  }

  // 受注仕様確認 受注一覧
  static listOrders = async (customerCode, edaban, bunrui) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listOrders');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      customerCode: customerCode,
      edaban: edaban,
      bunrui: bunrui
    }));
    return API.post(formdata, 'json');
  }

  // 受注仕様確認 受注取得
  static getOrder = async (albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getOrder');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      albumCode: albumCode
    }));
    return API.post(formdata, 'json');
  }

  // 受注仕様確認 確認状態
  static getOrderConfirm = async (albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getOrderConfirm');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      albumCode: albumCode
    }));
    return API.post(formdata, 'json');
  }

  // 受注仕様確認　状態保存
  static saveOrderConfirm = async (albumCode, data) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'saveOrderConfirm');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      albumCode: albumCode,
      data: data
    }));
    return API.post(formdata, 'json');
  }

  // 受注仕様確認　状態の複数取得
  static listOrderConfirm = async (customer, edaban, bunrui, updatedTimestamp) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listOrderConfirmWithTimestamp');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      customerCode: customer,
      edaban: edaban,
      bunrui: bunrui,
      timestamp: updatedTimestamp
    }));
    return API.post(formdata, 'json');
  }


  // 作成可能書類タイプの取得
  static listDocumentTypes = async () => {
    if (API_CACHE.hasOwnProperty('document_types')) {
      return new Promise((resolve, reject) => {
        resolve(API_CACHE.document_types);
      });
    }

    let formdata = new FormData();
    formdata.append('method', 'listDocumentTypes');
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType ='json';
      xhr.onload = function() {
        if (xhr.status === 200) {
          API_CACHE.document_types = xhr.response;
          resolve(xhr.response);
        }
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }

  // 書類フォーマットの取得
  static loadDocumentFormat = async (document_type) => {
    let formdata = new FormData();
    formdata.append('method', 'loadDocumentFormat');
    formdata.append('documentType', document_type);
    return API.post(formdata, 'json');
  }

  // 書類のSVGを取得
  static loadDocumentSVG = async (svgName) => {
    let formdata = new FormData();
    formdata.append('method', 'loadDocumentSVG');
    formdata.append('svgName', svgName);
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve(xhr.response);
        }
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }

  // 申請書一覧
  static listDocument = async (albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listDocument');
    formdata.append('idToken', idToken);
    formdata.append('albumCode', albumCode);
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType ='json';
      xhr.onload = function() {
        if (xhr.status === 200) resolve(xhr.response);
        else reject(xhr.statusText);
      }
      xhr.send(formdata);
    });
  }

  // 申請書　書類データの取得
  static loadDocumentData = async (type, docId) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'loadDocumentData');
    formdata.append('idToken', idToken);
    formdata.append('data', JSON.stringify({
      type: type,
      docId: docId
    }));
    return API.post(formdata, 'json');
  }

  // 申請の実行
  static requestDocument = async (albumCode, document) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'requestDocument');
    formdata.append('idToken', idToken);
    formdata.append('albumCode', albumCode);
    formdata.append('document', JSON.stringify(document));
    return API.post(formdata, 'json');
  }

  // 書類のPDFを取得
  static showDocumentPDF = async (docId) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getDocumentPDF');
    formdata.append('idToken', idToken);
    formdata.append('id', docId);
    return API.post(formdata, 'blob');
  }

  // Assistのカスタムログイン
  static loginToAssist = async (assistId) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'lgoinToAssist');
    formdata.append('idToken', idToken);
    formdata.append('assistId', assistId);
    return API.post(formdata, 'text');
  }

  // ProofPDF一覧を取得
  static listProofPDF = async (albumCode, pageKeys) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listProofPDF');
    formdata.append('idToken', idToken);
    formdata.append('albumCode', albumCode);
    formdata.append('pageKeys', JSON.stringify(pageKeys));
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType ='json';
      xhr.onload = function() {
        if (xhr.status === 200 && !xhr.response.error) resolve({
          code: albumCode,
          pdfList: xhr.response
        });
        else reject({
          code: albumCode,
          status: xhr.statusText
        });
      }
      xhr.send(formdata);
    });
  }
  // ProofPDFを取得
  static getProofPDF = async (oriuq) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getProofPDF');
    formdata.append('idToken', idToken);
    formdata.append('oriuq', oriuq);
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType ='blob';
      xhr.onload = function() {
        if (xhr.status === 200) {
          //console.log('PDFFileCreated:' + xhr.getResponseHeader('KM-PDFFileCreated'))

          var filename = (function () {
            var disposition = xhr.getResponseHeader('Content-Disposition');
            if (!disposition) return null;
            var m = disposition.match(/^.*filename\*=[^']+''([^;]+);.*$/);
            if (m) return decodeURIComponent(m[1]);
            m = disposition.match(/^.*filename="([^"]+)".*$/);
            if (m) return m[1];
            return '';
          })();

          let oriStatus = decodeURI(xhr.getResponseHeader('KM-OriStatus'));
          resolve({
            blob: xhr.response, 
            props: {
              PDFFileCreated: xhr.getResponseHeader('KM-PDFFileCreated'),
              PageText: xhr.getResponseHeader('KM-PageText'),
              OriStatus: oriStatus !== 'null' ? oriStatus : null,
              filename: filename,
            }
          });
        }
        else reject({
          error: xhr.statusText
        });
      }
      xhr.send(formdata);
    });
  }

  // PDFtoZIP
  static getProofPDFZip = async (oriuqs) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getProofPDFZip');
    formdata.append('idToken', idToken);
    formdata.append('oriuqs', JSON.stringify(oriuqs));
    return new Promise((resolve, reject)=>{
      let xhr = new XMLHttpRequest();
      xhr.open('post', api_url, true);
      xhr.responseType = 'blob';
      xhr.onload = function() {
        if (xhr.status === 200) {
          resolve({
            blob: xhr.response
          });
        }
        else reject( xhr.statusText );
      }
      xhr.send(formdata);
    });
  }

  // ファイルサーバへログインするためのSIDを取得する
  static getSidForLoginToFileServer = async(customerCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getSidForLoginToFileServer');
    formdata.append('idToken', idToken);
    formdata.append('customerCode', customerCode);
    return API.post(formdata, 'json');
  }

  // 緊急メッセージを取得する
  static loadCautions = async() => {
    let formdata = new FormData();
    formdata.append('method', 'loadCautions');
    return API.post(formdata, 'json');
  }

  // メモ
  static getMemo = async(albumCode) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getMemo');
    formdata.append('idToken', idToken);
    formdata.append('albumCode', albumCode);
    return API.post(formdata, 'json');
  }
  static saveMemo = async(albumCode, memo) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'saveMemo');
    formdata.append('idToken', idToken);
    formdata.append('albumCode', albumCode);
    formdata.append('memo', memo);
    return API.post(formdata, 'json');
  }


  // TOPICS RSS
  static getTopicsRSS = async() => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'getTopicsRSS');
    formdata.append('idToken', idToken);
    return API.post(formdata, 'text');
  }

  static getPublicFile = async(filename) => {
    return API.get({method:'getPublicFile', file:filename}, 'blob');
  }

  // デジタルカタログ一覧を取得
  static listDigitalCatalog = async() => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);
    let formdata = new FormData();
    formdata.append('method', 'listDigitalCatalog');
    formdata.append('idToken', idToken);
    return API.post(formdata, 'json');
  }
  static getDigitalCatalogInfo = async(catalogId) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);

    return new Promise((resolve, reject)=>{
      var worker = new Worker('/workers/getDigitalCatalogInfo.js');
      worker.addEventListener('message', function(e) {
        resolve(e.data);
        //reject(xhr.statusText);
      });
      worker.postMessage({url: api_url, idToken: idToken, catalogId: catalogId});
    });
  }
  static getDigitalCatalogPage = async(catalogId, page) => {
    const idToken = await firebase.auth().currentUser.getIdToken(false);

    return new Promise((resolve, reject)=>{
      var worker = new Worker('/workers/getDigitalCatalogPage.js');
      worker.addEventListener('message', function(e) {
        resolve(e.data);
        //reject(xhr.statusText);
      });
      worker.postMessage({url: api_url, idToken: idToken, catalogId: catalogId, page: page});
    });
  }
}